import { Form, Formik } from "formik";
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import {
  Upload,
  Input as TextInput,
  Select,
  DatePicker,
  AntTextArea,
} from "components/Antd";
import { CommonButton, ImageElement, RippleEffect } from "components/UiElement";
import Media from "apiEndPoints/Media";
import SweetAlert from "../../../../UiElement/SweetAlert";

import { validation } from "./validation";

export default function StepFormFive({
  t,
  onSubmit,
  loading,
  memberClick,
  setMemberClick,
  formData,
  nodeEditHandler,
  isEdit,
  setNodeData,
  setIsEdit,
  subscriptionData,
  familyTreeData,
  spouseClick,
  // setSpouseDetails,
  // spouseDetails,
  // nodeData,
  isMainNode,
  isAboveMainNode,
  // isFatherClick,
  selectedNodeHasSpouse,
  key,
  isAddParentBlocked,
  deletePaternalTreeIndividual,
  deleteIndividual,
  deleteSpouse,
  checkIfParentExists,
  familyTreeId,
  setFamilyTreeId
}) {
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedBirthDate, setSelectedBirthDate] = useState(
    undefined || dayjs(formData?.dateOfBirth)
  );
  const [selectedDeathhDate, setSelectedDeathDate] = useState(
    undefined || dayjs(formData?.dateOfDeath)
  );
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  useEffect(() => {
    if (formData?.dateOfBirth !== null) {
      setSelectedBirthDate(dayjs(formData?.dateOfBirth));
    }
    if (formData?.dateOfDeath !== null) {
      setSelectedDeathDate(dayjs(formData?.dateOfDeath));
    }
  }, [formData]);

  useEffect(() => {
    setImageUrl(null);
    setSelectedBirthDate(undefined);
    setSelectedDeathDate(undefined);
    setMemberClick("");
    setNodeData({});
    setIsEdit(false);
  }, [key]);

  let initialValues = {
    name: formData?.name || "",
    dateOfBirth: formData?.dateOfBirth || null,
    gender: formData?.gender || undefined,
    profileLink: formData?.profileLink || "",
    image: formData?.image || "",
    relation: formData?.relation || "",
    dateOfDeath: formData?.dateOfDeath || null,
  };

  const title = {
    add: "Add",
    addChild: "Add Child",
    addPartner: "Add Partner",
    addParents: "Add Parents",
  };

  const changeState = () => {
    setIsEdit(false);
    setNodeData({});
    setImageUrl();
  };

  const handleDeleteIndividual = () => {
    if(isAboveMainNode) {
      deletePaternalTreeIndividual();
    } else {
      if(spouseClick) {
        deleteSpouse();
      } else {
        deleteIndividual();
      }
    }
    setIsAlertVisible(false);
    changeState();
  }
  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        validationSchema={validation()}
        onSubmit={(values, { resetForm }) => {
          let data = { ...values };
          data.dateOfBirth = dayjs(values.dateOfBirth).format("YYYY-MM-DD");
          data.dateOfDeath = dayjs(values.dateOfDeath).format("YYYY-MM-DD");

          if (
            values?.dateOfDeath === "" ||
            values?.dateOfDeath === undefined ||
            values?.dateOfDeath === null
          ) {
            data.dateOfDeath = null;
          }
          if (
            values?.dateOfBirth === "" ||
            values?.dateOfBirth === undefined ||
            values?.dateOfBirth === null
          ) {
            data.dateOfBirth = null;
          }
          onSubmit(data);
          setImageUrl(null);
          resetForm();
        }}
        enableReinitialize
      >
        {(props) => {
          return (
            <Col lg={4} xl={3}>
              <div className="stepsContent_profile bg-white mb-3 mb-lg-0">
                <Form>
                  {memberClick === "memberClick" ? (
                    <>
                      <div className="stepsContent_option">
                        {(isAboveMainNode === true &&
                          spouseClick === true &&
                          isAddParentBlocked === false) && (
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                // Check if there's already a parent for this node
                                const existingParent = checkIfParentExists ? checkIfParentExists(familyTreeId) : null;
                                
                                if (existingParent && (existingParent.paternalTreeRecord ? !existingParent.spouseId : !existingParent.spouse?.length)) {
                                  // If parent exists but has no spouse, switch to add partner mode
                                  setFamilyTreeId(existingParent.id);
                                  setMemberClick("addPartner");
                                  setIsEdit(false)
                                  setNodeData({})
                                } else {
                                  changeState();
                                  setMemberClick("addSpouseParent");
                                }
                              }}
                            >
                              Add Parents
                            </Link>
                          )}

                        {(isAboveMainNode === true) && (
                          <>
                            {isAddParentBlocked === false && spouseClick === false &&
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  // Check if there's already a parent for this node
                                  const existingParent = checkIfParentExists ? checkIfParentExists(familyTreeId) : null;
                                  
                                  if (existingParent && (existingParent.paternalTreeRecord ? !existingParent.spouseId : !existingParent.spouse?.length)) {
                                    // If parent exists but has no spouse, switch to add partner mode
                                    setFamilyTreeId(existingParent.id);
                                    setMemberClick("addPartner");
                                    setIsEdit(false)
                                    setNodeData({})
                                  } else {
                                    // Otherwise, proceed with adding parents
                                    changeState();
                                    setMemberClick("addParents");
                                  }
                                }}
                              >
                                Add Parents
                              </Link>
                            }
                            {/* if spose exist do not show this button else show this button */}
                            {!selectedNodeHasSpouse && spouseClick === false &&
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  changeState();
                                  setMemberClick("addPartner");
                                }}
                              >
                                Add Partner
                              </Link>
                            }
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                changeState();
                                setMemberClick("addChild");
                              }}
                            >
                              Add Child
                            </Link>
                            {/* TODO: Need to figure out how to delete above main node */}
                            {!isMainNode && (
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  setIsAlertVisible(true)
                                }}
                              >
                                Delete
                              </Link>
                            )}
                            {/* <Link onClick={() => setMemberClick("add")}>Add Siblings</Link> */}
                          </>
                        )}

                        {(isAboveMainNode === false) && (
                          <>
                          {spouseClick === false && (
                            <>
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  // Check if there's already a parent for this node
                                  const existingParent = checkIfParentExists ? checkIfParentExists(familyTreeId) : null;
                                  
                                  if (existingParent && !existingParent.spouse?.length) {
                                    // If parent exists but has no spouse, switch to add partner mode
                                    setFamilyTreeId(existingParent.id);
                                    setMemberClick("addPartner");
                                    setIsEdit(false)
                                  } else {
                                    // Otherwise, proceed with adding parents
                                    changeState();
                                    setMemberClick("addParents");
                                  }
                                }}
                              >
                                Add Parents
                              </Link>
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  changeState();
                                  setMemberClick("addPartner");
                                }}
                              >
                                Add Partner
                              </Link>
                            </>
                          )}
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                changeState();
                                setMemberClick("addChild");
                              }}
                            >
                              Add Child
                            </Link>
                            {!isMainNode && (
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  setIsAlertVisible(true)
                                }}
                              >
                                Delete
                              </Link>
                            )}
                          </>
                        )}
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            nodeEditHandler();
                          }}
                        >
                          Edit Details
                        </Link>
                      </div>
                    </>
                  ) : memberClick === "addPartner" ||
                    memberClick === "addChild" ||
                    memberClick === "addParents" ||
                    memberClick === "edit" ||
                    memberClick === "addSpouseParent" ||
                    familyTreeData?.length === 0 ? (
                    <>
                      <h2 className="fw-semibold">
                        {memberClick === "edit"
                          ? "Edit"
                          : title[memberClick || "add"]}{" "}
                        Details
                      </h2>
                      <div className="uploadProfile">
                        <div className="position-relative">
                          {formData?.imageUrl || imageUrl ? (
                            <ImageElement
                              previewSource={imageUrl || formData?.imageUrl}
                              alt="Default-profile"
                            />
                          ) : (
                            <div className="userDefault">
                              <ImageElement
                                previewSource="/assets/images/frontend/userDefault.png"
                                alt="Default-profile"
                              />
                            </div>
                          )}
                          <Upload
                            apiEndPoints={Media.mediaUpload(
                              "family-tree",
                              "image"
                            )}
                            name="image"
                            type="file"
                            aspect={1 / 1}
                            setFieldValue={props.handleChange}
                            // imageUrl={imageUrl}
                            setImageUrl={setImageUrl}
                            applyImageCropper
                            defaultImageUrl={formData?.imageUrl}
                            validateFileType={[
                              "image/jpeg",
                              "image/png",
                              "image/jpg",
                            ]}
                            query
                            subscriptionData={subscriptionData}
                          >
                            <em className="icon-camera" />
                          </Upload>
                        </div>
                      </div>
                      <Row className="g-3 asideForm">
                        <Col lg={12} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label form-label-md">
                              {t("text.createMemories.fullNameLabel")}
                            </label>
                            <TextInput
                              id="fullName"
                              name="name"
                              className="form-control form-control-md"
                              placeholder={t(
                                "text.createMemories.enterFullName"
                              )}
                            />
                          </div>
                        </Col>
                        <Col lg={12} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label form-label-md">
                              {t("text.createMemories.genderLabel")}
                            </label>
                            <Select
                              className="w-100 selectPicker selectPicker-md"
                              placeholder={t(
                                "text.createMemories.selectGender"
                              )}
                              name="gender"
                              options={[
                                { value: "male", label: "Male" },
                                { value: "female", label: "Female" },
                                { value: "other", label: "Other" },
                              ]}
                            />
                          </div>
                        </Col>

                        <Col lg={12} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label form-label-md">
                              Relation
                            </label>
                            <TextInput
                              id="relation"
                              name="relation"
                              className="form-control form-control-md"
                              placeholder="Enter Relation"
                              maxLength={50}
                            />
                          </div>
                        </Col>

                        <Col lg={12} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label form-label-md">
                              {t("text.createMemories.birthDate")}
                              <span className="form-label-date">
                                [MM-DD-YYYY]
                              </span>
                            </label>
                            <DatePicker
                              id="dateOfBirth"
                              name="dateOfBirth"
                              placeholder={t(
                                "text.createMemories.selectBirthDate"
                              )}
                              className="form-control form-control-md"
                              suffixIcon={<em className="icon-calendar" />}
                              validation
                              onSelectChange={(e) => {
                                setSelectedBirthDate(e);
                                props.setFieldValue("dateOfBirth", e);
                              }}
                              value={
                                formData?.dateOfBirth === null ||
                                  formData?.dateOfBirth === undefined
                                  ? undefined
                                  : selectedBirthDate
                              }
                              disabledDate={(current) => {
                                return (
                                  current && current > dayjs().endOf("day")
                                );
                              }}
                            />
                          </div>
                        </Col>

                        <Col lg={12} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label form-label-md">
                              {t("text.createMemories.deathDate")}
                              <span className="form-label-date">
                                [MM-DD-YYYY]
                              </span>
                            </label>
                            <DatePicker
                              id="dateOfDeath"
                              name="dateOfDeath"
                              placeholder={t(
                                "text.createMemories.selectDeathDate"
                              )}
                              className="form-control form-control-md"
                              validation
                              onSelectChange={(e) => {
                                setSelectedDeathDate(e);
                                props.setFieldValue("dateOfDeath", e);
                              }}
                              value={
                                formData?.dateOfDeath === null ||
                                  formData?.dateOfDeath === undefined
                                  ? undefined
                                  : selectedDeathhDate
                              }
                              disabledDate={(current) => {
                                return (
                                  current &&
                                  (current > dayjs().endOf("day") ||
                                    current <
                                    dayjs(props?.values?.dateOfBirth).startOf(
                                      "day"
                                    ))
                                );
                              }}
                            />
                          </div>
                        </Col>
                        <Col sm={12}>
                          <div className="form-group mb-0">
                            <label className="form-label form-label-md">
                              {t("text.createMemories.profileLinkLabel")}
                            </label>
                            <AntTextArea
                              className="form-control form-control-md h-auto"
                              name="profileLink"
                              placeholder={t(
                                "text.createMemories.enterProfileLink"
                              )}
                              size="large"
                              maxLength={150}
                            />
                          </div>
                        </Col>
                        <Col sm={12}>
                          <p className="fw-normal text-center changeDetails">
                            You Can Also Add Or Change Details Later.
                          </p>
                          <div className="d-flex flex-wrap">
                            <RippleEffect extraClassName="w-50 pe-3">
                              {memberClick === "addPartner" ||
                                memberClick === "addChild" ||
                                memberClick === "addParents" ||
                                memberClick === "addSpouseParent" ||
                                memberClick === "edit" ? (
                                <CommonButton
                                  onClick={() => setMemberClick("memberClick")}
                                  variant="light"
                                  className="btn-sm w-100"
                                >
                                  {t("text.common.cancel")}
                                </CommonButton>
                              ) : (
                                <></>
                              )}
                            </RippleEffect>
                            <RippleEffect extraClassName="w-50 justify-content-end">
                              <CommonButton
                                variant="danger"
                                className="btn-sm w-100"
                                type="submit"
                                loading={loading}
                              >
                                {isEdit
                                  ? t("text.common.update")
                                  : t("text.common.submit")}
                              </CommonButton>
                            </RippleEffect>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <div className="h-100 stepsContent_profile bg-white mb-3 mb-lg-0 text-center">
                        <div>Please Select Node First</div>
                      </div>
                    </>
                  )}
                </Form>
              </div>
            </Col>
          );
        }}
      </Formik>
      <SweetAlert
        reverseButtons
        title="Delete Individual"
        text={`Are you sure want to delete?${isAboveMainNode ? !spouseClick ? " This will delete all spouses and associated ancestors above this tree record" : " This will delete all associated ancestors above this tree record" : !spouseClick ? " This will delete all associated children and spouses." : ""}`}
        show={isAlertVisible}
        icon="warning"
        showCancelButton
        cancelButtonText="No"
        confirmButtonText="Yes"
        confirmButtonColor="#fcb040"
        setIsAlertVisible={setIsAlertVisible}
        showLoaderOnConfirm
        // loading={loading}
        onConfirmAlert={() => handleDeleteIndividual()}
      />
    </>
  );
}
